angular.module("modules:mapping").directive("contextMenu", function () {
  return {
    templateUrl: "/directives/mapping/context-menu.html",
    scope: {
      sections: "=",
      select: "=",
    },
  };
});
